import { render, staticRenderFns } from "./shareFooterUp.vue?vue&type=template&id=3e8782c0&scoped=true&"
import script from "./shareFooterUp.vue?vue&type=script&lang=js&"
export * from "./shareFooterUp.vue?vue&type=script&lang=js&"
import style0 from "./shareFooterUp.vue?vue&type=style&index=0&id=3e8782c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8782c0",
  null
  
)

export default component.exports